<template>
  <div>
    <panel title="Moduły">
      <w-table
        entity-type="module"
        :hide-search-input="true"
        :columns="columns"
        :data="list"
        :actions="actions"
        :total="count"
        @add="showAddModal"
        @edit="showEditModal($event.id)"
        @delete="showDeleteDialog($event.id)"
      />
    </panel>

    <module-modal :id="idToEdit" :show="showModal" @save="add" @close="hideModal" @update="update" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ModuleModal from '@/components/modals/ModuleModal';
import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania modułów.',
  getError: 'Wystąpił błąd podczas pobierania danych modułu.',
  added: 'Dodano moduł.',
  addError: 'Nie udało się dodać modułu.',
  updated: 'Zaktualizowano dane modułu.',
  updateError: 'Nie udało się zaktualizować danych modułu.',
  deleteConfirm: 'Czy na pewno chcesz usunąć moduł?',
  deleted: 'Usunięto modułu.',
  deleteError: 'Nie udało się usunąć modułu.'
};

// @vuese
// Lista modułów
// @group Module
export default {
  components: { Panel, WTable, ModuleModal },
  mixins: [listMixin('module', messages)],
  data: () => ({
    columns: [{ name: 'id', displayName: 'ID' }, { name: 'name', displayName: 'Nazwa', sortable: true }],
    actions: DEFAULT_TABLE_ACTIONS
  })
};
</script>